//```import constants types
import {
  VIDFLEET_CONFIGURATION_LOAD,
  VIDFLEET_CONFIGURATION_LOAD_RESULT,
  VIDFLEET_CONFIGURATION_SAVE,
  VIDFLEET_CONFIGURATION_SAVE_RESULT,
  VIDFLEET_CONFIGURATION_GET_DEVICE_INFO,
  VIDFLEET_CONFIGURATION_GET_DEVICE_INFO_RESULT,
  VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE,
  VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE_RESULT,
  VIDFLEET_CONFIGURATION_BULK_MODAL_SHOW,
  VIDFLEET_CONFIGURATION_BULK_MODAL_HIDE
} from 'Redux/actionTypes';


export const vidfleetConfigurationLoadData = (deviceESN, devices) => ({
  type: VIDFLEET_CONFIGURATION_LOAD,
  payload: { deviceESN: deviceESN, devices: devices }
});

export const vidfleetConfigurationLoadDataResult = (data) => ({
  type: VIDFLEET_CONFIGURATION_LOAD_RESULT,
  payload: data
});

export const vidfleetConfigurationSave = (data) => ({
  type: VIDFLEET_CONFIGURATION_SAVE,
  payload: data
});

export const vidfleetConfigurationSaveResult = (data) => ({
  type: VIDFLEET_CONFIGURATION_SAVE_RESULT,
  payload: data
});

export const vidfleetConfigurationGetDeviceData = (deviceESN) => ({
  type: VIDFLEET_CONFIGURATION_GET_DEVICE_INFO,
  payload: { deviceESN: deviceESN }
});

export const vidfleetConfigurationGetDeviceDataResult = (data) => ({
  type: VIDFLEET_CONFIGURATION_GET_DEVICE_INFO_RESULT,
  payload: data
});

export const vidfleetConfigurationSettingsToClone = (serialEsn) => ({
  type: VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE,
  payload: { serialEsn: serialEsn }
});

export const vidfleetConfigurationSettingsToCloneResult = (res) => ({
  type: VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE_RESULT,
  payload: { res }
});

export const vidfleetConfigurationBulkOpenModal = () => ({
  type: VIDFLEET_CONFIGURATION_BULK_MODAL_SHOW,
  payload: {  }
});

export const vidfleetConfigurationBulkModalHide = () => ({
  type: VIDFLEET_CONFIGURATION_BULK_MODAL_HIDE,
  payload: {}
});